import Vue from "vue";
import Router from "vue-router";
import VueResource from 'vue-resource'
import VueScrollTo from 'vue-scrollto'
import Meta from 'vue-meta'
import VeeValidate from 'vee-validate';
import VueAnalytics from 'vue-analytics'
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
import Monitoring from "./pages/Monitoring.vue";
import ArticleNew from "./pages/Article_Create.vue";
import ArticleEdit from "./pages/Article_Edit.vue";
import Article from "./pages/Article.vue";
import NotFound from "./pages/404.vue";

Vue.use(VueResource);
Vue.use(Router);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 700,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(Meta)
Vue.use(VeeValidate);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "Facility Refrigeration Monitoring",
      components: {
        default: Monitoring,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/article/add",
      name: "New Article",
      components: {
        default: ArticleNew,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/article/edit",
      name: "Edit Article",
      components: {
        default: ArticleEdit,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/article",
      name: "Facility Refrigeration Articles",
      components: {
        default: Article,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: '*',
      components: {
        default: NotFound,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
});
Vue.use(VueAnalytics, {
  id: ['UA-89795959-13', 'AW-788605961'],
  disableScriptLoader: true,
  router
})
export default router;
